import Icons from "@/src/components/Icons";

interface shippingProps {
  data: any;
  onClick?: any;
}

function ShippingItem({ data, onClick }: shippingProps) {
  return (
    <>
      <div
        className={`item rounded-xl  shadow-mmpz min-h-[78px] border p-3 relative cursor-pointer ${
          data && data.status && data.status.code === "DELIVERED" || data.status.code === "DELIVERING"
            ? "border-success"
            : "border-gray-100-mmpz"
        }`}
        onClick={onClick}
      >
        <h6
          className={`text-lg font-bold ${
            data &&
            data.status &&
            data.status.code == "SCHEDULED" &&
            "text-gray-200-mmpz"
          }`}
        >
          {data &&
            data.receiverAddress &&
            data.receiverAddress.addressOwnerName}
        </h6>
        <div className=" flex gap-2 items-center justify-between  mt-2 w-full">
          <div className="rounded shadow-mmpz p-2 gap-4 flex items-center">
            <span className="flex items-center gap-2 text-sm ">
              {(data && !data.status) || data.status.code == "CANCELLED" ? (
                <>
                  <Icons name="car" />{" "}
                  <span className="text-gray-200-mmpz">تعیین نشده</span>
                </>
              ) : (
                <>
                  <Icons name="car" />{" "}
                  <span
                    className={`${
                      data && data.provider && data.provider.code == "TAPSI"
                        ? "text-primary-300"
                        : data && data.provider && data.provider.code == "SNAPP_BOX"
                        ? "text-[#00D170]"
                        : "text-[#0099FF]"
                    }`}
                  > 
                    {data.provider.name}
                  </span>
                </>
              )}
            </span>
            <span className="flex items-center gap-2  text-sm">
              {(data && !data.status) || data.status.code == "CANCELLED" ? (
                <>
                  <Icons name="deliveryModel" size={28} />{" "}
                  <span className="text-gray-200-mmpz">تعیین نشده</span>
                </>
              ) : (
                <>
                  <Icons name="deliveryModel" size={28} />{" "}
                  {data && data.courierVehicleName ? (
                    data.provider.name == "الوپیک" ? (
                      data.courierPhoneNumber
                    ) : (
                      data.courierVehicleName
                    )
                  ) : (
                    <span className="text-gray-200-mmpz">تعیین نشده</span>
                  )}
                </>
              )}
            </span>
          </div>
          {/* <div className="rounded shadow-mmpz p-2 flex gap-1 font-bold">
            <Icons name="time" />
            ۱۰:۱٤
          </div> */}
        </div>
        <div className="absolute top-2 left-2 flex items-center gap-2">
          <span>
            {data && data.status && data.status.code !== "SCHEDULED" && (
              <Icons
                name={
                  data.status.code == "CANCELLED"
                    ? "deliveryStatusCancel"
                    : data.status.code == "PICKING"
                    ? "deliveryStatusPending"
                    : data.status.code == "ACCEPTED"
                    ? "deliveryStatusAccess"
                    : ""
                }
                size={24}
              />
            )}
          </span>
          <span>
            <Icons name="moreIcon" size={30} />
          </span>
        </div>
      </div>
    </>
  );
}

export default ShippingItem;
